import type {
  OrgResponse,
  PlatformOnboardingPipeline,
} from "@bw/shared/types/generated";

import type { StatusFilter } from "./components/ApprovalFilterBar";
import { ownerDisplayName } from "./components/terms";

export const APPROVAL_PAGE_SIZE = 10;

export const EMPTY_APPROVAL_PIPELINE: PlatformOnboardingPipeline = {
  pending: [],
  in_review: [],
  approved: [],
};

export function approvalPaginationLabel(
  type: string,
  page: number | null,
): string {
  if (type === "next") return "Next";
  if (type === "previous") return "Previous";
  if (type === "first") return "First";
  if (type === "last") return "Last";
  return page === null ? "More pages" : `Page ${page}`;
}

export function filterBucket(
  pipeline: PlatformOnboardingPipeline,
  filter: StatusFilter,
): OrgResponse[] {
  if (filter === "Pending") return pipeline.pending;
  if (filter === "In Review") return pipeline.in_review;
  if (filter === "Approved") return pipeline.approved;
  return [...pipeline.pending, ...pipeline.in_review, ...pipeline.approved];
}

export function matchesApprovalSearch(
  org: OrgResponse,
  search: string,
): boolean {
  if (!search) return true;
  const owner = ownerDisplayName(org);
  const safeOwner = owner === "Owner unavailable" ? "" : owner;
  return [org.business_name, org.legal_name, safeOwner]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .includes(search);
}
